
import { useCallback, useEffect, useRef, useState } from "react";
import { checkNetworkConnectivity, GetSystemHealth } from "../requests/backendHealth";
import { useLocation } from "react-router-dom";

export function useSystemHealth(interval?: number | null) {
    const [systemIsHealthy, setSystemIsHeath] = useState(true)
    const [hasNetworkConnection, setHasNetworkConnection] = useState(true)
    const { pathname } = useLocation();
    const intervalRef = useRef<NodeJS.Timeout | null>(null);


    const fetchHealth = useCallback(async () => {
        try {
            const isHealthy = await GetSystemHealth();
            setSystemIsHeath(isHealthy);
            setHasNetworkConnection(true);
        } catch (error) {
            const networkResult = await checkNetworkConnectivity();
            if (!networkResult)
                setHasNetworkConnection(false);
            else
                setSystemIsHeath(false);

        }
    }, []);

    useEffect(() => {
        fetchHealth();

        if (!intervalRef.current && (!systemIsHealthy || !hasNetworkConnection)) {
            intervalRef.current = setInterval(fetchHealth, 5000);
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };

    }, [pathname, systemIsHealthy, hasNetworkConnection, fetchHealth, interval]);

    return { systemIsHealthy, fetchHealth, hasNetworkConnection };
}

